import EDClassList from "./EDClassList.js"
import EDAttribList from "./EDAttribList.js"
import EDDataset from "./EDDataset.js"
import EDEventListener from "./EDEventListener.js"
import EDChild from "./EDChild.js"

export default class EDDom {

    setText(pText) {
        this._text = pText

        if(this._DOMElement) {
            this._DOMElement.textContent = pText
        }
    }

    setHTML(pHTML) {
        this._html = pHTML

        if(this._DOMElement) {
            this._DOMElement.innerHTML = pHTML
        }
    }

    getText() {
        return this._text
    }

    getElementId() {
        if(!window.ED_DOM_MAP) {
            window.ED_DOM_MAP = new Map()
        }

        if(!window.ED_DOM_MAP.has(this.constructor.name)) {
            window.ED_DOM_MAP.set(this.constructor.name, 1)
            return this.constructor.name + "_1"
        }

        let counter = window.ED_DOM_MAP.get(this.constructor.name) + 1
        window.ED_DOM_MAP.set(this.constructor.name, counter)
        return this.constructor.name + "_" + counter
    }

    setParent(pParent) {
        this._EDParent = pParent
    }

    getDOMId() {
        return this.dataset.getDOMId()
    }

    createElement() {
        return document.createElement(this._tagName)
    }

    render() {

        if(!this._DOMElement) {

            if(!this._tagName) {
                throw "ED_DOMElement requires a tagName"
            }
    
            if(!this._isRoot) {
                this._DOMParent = this._EDParent._DOMElement
            }

            this._DOMElement = this.createElement()
            this.classList.render()
            this.attrib.render()
            this.dataset.render()
            this.eventListener.render()

            if(typeof this._text !== 'undefined') {
                this._DOMElement.innerText = this._text
            }

            if(typeof this._html !== 'undefined') {
                this._DOMElement.innerHTML = this._html
            }

            this._DOMParent.appendChild(this._DOMElement)

            this.children.render()
    
            window.VDOMMAP.set(this.getDOMId(), this)
    
            this.afterRender()

            return this._DOMElement
        }

        this.children.forEach(element => {
            element.render(this.DOMElement)
        })
        
        return this.DOMElement
    }

    afterUnrender(pDomId) {}

    unrender() {
        if(this._DOMElement) {
            const domId = this.getDOMId()
            this.children.unrender()
            window.VDOMMAP.delete(domId)
            this._DOMElement.remove()
            this._DOMElement = undefined
            this.afterUnrender(domId)
        }
    }

    remove() {
        const domId = this.getDOMId()
        this.unrender()
        
        if(!this._isRoot) {
            this._EDParent.children.remove(domId)
        }
    }

    getChildInstance(pAppend) {
        return new EDChild(
            this,
            pAppend
        )
    }

    afterRender() {}
  
    constructor(p) {
        
        p.text = p.append ? undefined : p.text
        
        this._tagName = p.tagName
        this.classList = new EDClassList(this, p.class)
        this.attrib = new EDAttribList(this, p.attrib)
        this.dataset = new EDDataset(this, p.dataset)
        this.eventListener = new EDEventListener(this, p.events)
        this.children = this.getChildInstance(p.append)
        this.dataset.add("eddomid", this.getElementId())
        this.dataset.add("objectid", p.objectId)
        this.attrib.add("tabindex", p.tabIndex)
        this.attrib.add("id", p.id)
        
        if(p.parent && (p.parent instanceof Element)) {
            
            this._isRoot = true
            this._DOMParent = p.parent
                        
            if(p.initRoot != false) {
                this._DOMParent.innerHTML = null
            }

            if(!window.VDOMMAP) {
                window.VDOMMAP = new Map()
            }
        }

        if(p.store) {
            p.store(this)
        }

        this.setText(p.text)

        if(p.html) {
            this.setHTML(p.html)
        }
    }
}